import React, { useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { GridNode } from '../common/shared/grid-item'
import { CourseMenu } from '../common/menu/node-actions'
import { IconCourse, IconVideo } from '../../../../../shared/icon/icon'

export const NodeContentGridItemVideo = ({ node, dataContext }) => {
  const { url } = useRouteMatch()

  const to = useMemo(() => `${url}/course/${node.id}`, [url, node])

  const FooterMenu = () => <CourseMenu place="card" url={`${url}/course/${node.id}`} node={node} nodeID={node.id} />

  return <GridNode Icon={IconCourse} FooterMenu={FooterMenu} Overlay={VideoOverlay} node={node} to={to} dataContext={dataContext} />
}

const VideoOverlay = () => {
  return (
    <div style={{ textDecoration: 'none', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', opacity: '70%' }}>
      <IconVideo transform="grow-30" />
    </div>
  )
}
